import React from "react";
import { TopToolbar, ExportButton } from "react-admin";
import Tooltip from "@mui/material/Tooltip";

import { useMaxResultsByPlan } from "../../helpers/subscriptionPlan";

const ListActions = (props) => {
  const maxResults = useMaxResultsByPlan();

  return (
    <TopToolbar>
      <Tooltip title={`Max Export = ${maxResults} logs`}>
        <span>
          <ExportButton maxResults={maxResults} />
        </span>
      </Tooltip>
    </TopToolbar>
  );
};

export default ListActions;
